import Axios from 'axios'
import qs from 'query-string'
import moment from 'moment'

export const sendDataToWebToLead = async (formData) => {
  try {
    await Axios.post(
      `https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8`,
      qs.stringify({
        oid: '00D2X000000rxZ1',
        first_name: formData.bookingValues.name,
        last_name: formData.bookingValues.surname,
        email: formData.bookingValues.email,
        mobile: formData.bookingValues.phone,
        '00N2X00000BEyWA': moment(formData.bookingValues.date).format('DD/MM/YYYY'), // VISIT DATE
        '00N2X00000BEyVg': formData.bookingValues.time, // VISIT TIME
        street: formData.property.street,
        city: formData.property.city,
        zip: formData.property.cap,
        state: formData.property.province,
        country: formData.property.country,
        url: `${process.env.REACT_APP_WEBSITE}/it/property/${formData.property.id}/detail`,
      }),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    )
    return {
      error: false,
    }
  } catch (e) {
    // SE NON INSERISCE NON FA NULLA FACCIAMO PROSEGUIRE
    return {
      error: false,
    }
  }
}
